import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vndaufxufftwkdiwjgji.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZuZGF1Znh1ZmZ0d2tkaXdqZ2ppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwNjgxMDcsImV4cCI6MjA2NzY0NDEwN30.mXEX_yJZEu_QxPF54WseIBCX51jsjGbmAo03e4qajHw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);